import './ListItem';
import ListItem from "./ListItem";
import NP from "../../NP";

export default class ListItemCheckBox extends ListItem {

	constructor(settings: object)
	{
		super(settings);
	}

	_render()
	{
		let cnt = this._Content || NP.RM.getString(this._RK) || '',
			 titleAttr = this._AddToolTips ? ` title="${cnt}" ` : '';
		cnt = `<span class="app-list-item__text">${cnt}</span>`;

		if (this._FontImage)
			this.np_render(`<li class="app-list-item"  ${titleAttr}>
<span class="app-list-item__graphic ${this._FontImage}"></span>${cnt}<span class="app-list-item__meta ${NP.FontImages.check_box_outline}"></span>
</li>`);
		else
			this.np_render(`<li class="app-list-item" ${titleAttr}>
<span  class="app-list-item__graphic ${NP.FontImages.check_box_outline}"></span>${cnt}
</li>`);

		if (this._Selected)
			this.setSelected(true);
	}

	setSelected(value: boolean)
	{
		this._Selected = value;
		let node = this._FontImage ? this._root.querySelector('.app-list-item__meta') : this._root.querySelector('.app-list-item__graphic');
		if (value)
		{
			NP.addCssClass(node, NP.FontImages.check_box);
			NP.removeCssClass(node, NP.FontImages.check_box_outline);
		}
		else
		{
			NP.addCssClass(node, NP.FontImages.check_box_outline);
			NP.removeCssClass(node, NP.FontImages.check_box);
		}
	}
}